import AuthForm from '@/components/auth/auth_form/AuthForm.vue';
import AuthHeader from '@/components/auth/auth_header/AuthHeader.vue';

export default {
  data: function() {
    return {};
  },
  mixins: [],
  components: {
    AuthForm,
    AuthHeader
  },
  methods: {}
};
